<div class="properties-row">    
    <app-widget-select [items]="queues$|async" bindValue="id" bindLabel="description" [model]="gridItem.setup.queueIds" title="{{ 'dashboard:Select Queues' | i18next }}"
                       (modelChange)="gridItem.setup.queueIds=$event" (modelChange)="modelChange()">
    </app-widget-select>

    <app-widget-select [items]="queueProperties$|async" bindLabel="name" [model]="gridItem.setup.queuePropertiesIds" title="{{ 'dashboard:Select Queues Columns' | i18next }}"
                       bindValue="id" (modelChange)="gridItem.setup.queuePropertiesIds=$event" (modelChange)="modelChange()" [translateItems]="true">
    </app-widget-select>

    <app-widget-type-select [widgetType]="gridItem.type" (modelChange)="gridItem.type=$event" (modelChange)="modelChange()" title="{{ 'dashboard:Visual Type' | i18next }}"
                            [disabledItems]="visualTypedisabledItems">
    </app-widget-type-select>
</div>
<div class="properties-row sort-row" *ngIf="isSortingVisible">
  <label>{{ 'dashboard:Row sorting' | i18next }}</label><br /><br />
  <app-manual-row-sort [items]="manualRowOrderItems" [gridItem]="gridItem" bindLabel="description" bindValue="id"></app-manual-row-sort>  
  <div *ngIf="!isManualRowOrderEnabled">
    <app-sort-select [properties]="queueProperties" [gridItem]="gridItem" [items]="gridItem.setup.queuePropertiesIds"></app-sort-select><br />
    <app-sort-select *ngIf="isSecondLevelSortingEnabled" [properties]="queueProperties" [gridItem]="gridItem" [items]="gridItem.setup.queuePropertiesIds" [isSecondSorting]="true"></app-sort-select>
  </div>  
</div>
